/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConfirmPostRecentModal from 'app/components/common/ConfirmPostRecentModal.jsx';
import CreateFeedOutputPanel from 'app/components/EditorComponents/CreateFeedOutputPanel.jsx';
import Modal from 'app/components/common/Modal.jsx';
import RouteProvider from 'app/redux/Providers/RouteProvider.jsx';
import SocialModalFooter from 'app/components/SocialModal/SocialModalFooter.jsx';
import SocialSelection from 'app/components/SocialModal/SocialSelection.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import TypeSelection from 'app/components/SocialModal/TypeSelection.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import FBTypeChooser from 'app/components/SocialModal/FBTypeChooser.jsx';
import MastodonHandle from 'app/components/SocialModal/MastodonHandle.jsx';
import BlueskyCreds from 'app/components/SocialModal/BlueskyCreds.jsx';
import * as _ from 'underscore';

class SocialModal extends React.Component {
	constructor(props) {
		super(props);

		let selectedSocials = [],
			originalSet = [];

		if (props.selectedSocials && Array.isArray(props.selectedSocials)) {
			selectedSocials = [...props.selectedSocials];
			originalSet = [...props.selectedSocials];
		}

		this.state = {
			originalSet: originalSet,
			selectedSocials: selectedSocials,
			activeTab: props.activeTab,
			context: 'list',
			errors: [],
			isDirty: false,
			serviceId: 0,
			twitterMaxedOut: false,
			mainTweeter: 0,
			inceptionModal: null
		};

		this.filterSocialsByName = this.filterSocialsByName.bind(this);
		this.filterSocialsByType = this.filterSocialsByType.bind(this);
		this.switchView = this.switchView.bind(this);
		this.setInceptionModal = this.setInceptionModal.bind(this);
		this.socialClickHandler = this.socialClickHandler.bind(this);
		this.saveDialog = this.saveDialog.bind(this);
		this.saveDialogConfirm = this.saveDialogConfirm.bind(this);
		this.saveDialogCancel = this.saveDialogCancel.bind(this);
		this.onSocialsSelected = this.onSocialsSelected.bind(this);
		this.getSocialsToAdd = this.getSocialsToAdd.bind(this);
		this.saveHandler = this.saveHandler.bind(this);
		this.setMainTweeter = this.setMainTweeter.bind(this);
		this.resetTwitters = this.resetTwitters.bind(this);

	}

	static getDerivedStateFromProps(props, state) {
		let nextState = {},
			selectedSocials = [],
			originalSet = [],
			constants = props.app.config.constants;

		if (state.originalSet.length === 0 && props.outputs.length) {
			for (let i = 0; i < props.outputs.length; ++i) {
				selectedSocials.push(props.outputs[i].social.id);
				originalSet.push(props.outputs[i].social.id);
				if (props.outputs[i].role == constants.OR_ROLE_NORMAL && props.outputs[i].social.psID == constants.POST_SVC_TWITTER) {
					nextState.mainTweeter = props.outputs[i].social.id;
				}
			}

			if (selectedSocials.length) {
				nextState.selectedSocials = selectedSocials;
			}

			if (originalSet.length) {
				nextState.originalSet = originalSet;
			}

		}

		return (Object.keys(nextState).length) ? nextState : null;

	}

	componentDidMount() {

		// reset any prior sort and filter
		this.props.clearFilter('socials');
		this.props.sortStore('socials', 'name', 'ASC');

		// get types list
		this.props.getSocialTypes();

	}

	componentWillUnmount() {
		if (this.props.clearFilterOnClose) {
			this.props.clearFilter('socials');
		}
	}

	filterSocialsByName(e, search) {
		if (this.state.serviceId) {
			this.props.filterStore('socials', ['psID'], this.state.serviceId.toString(), true);
			this.props.filterStore('socials', ['name'], search, false, true);
		} else {
			this.props.filterStore('socials', ['name'], search);
		}
	}

	filterSocialsByType(e, key) {
		if (key === '') {
			this.props.clearFilter('socials');
		} else {
			this.props.filterStore('socials', ['psID'], key, true);
		}
	}

	switchView(view, serviceId) {
		let svcId = serviceId || 0;

		if (svcId) {
			this.props.filterStore('socials', ['psID'], svcId.toString(), true);
		}
		this.setState({
			activeTab: view,
			serviceId: svcId
		});
	}

	setInceptionModal(modal) {
		this.setState({
			inceptionModal: modal
		});
	}

	socialClickHandler(e) {
		let newId = parseInt(e.currentTarget.dataset.id, 10),
			idList = this.state.selectedSocials,
			twitterMaxedOut = false,
			index = 0,
			isDirty = this.state.isDirty,
			i = 0,
			diff = [],
			constants = this.props.app.config.constants,
			twitterCount = 0,
			test = null,
			mainTweeter = this.state.mainTweeter;

		if (newId !== 0 && idList.find((id) => { return newId === id; }) === undefined) {
			let social = _.find(this.props.socials.list, (social) => {
				return newId == social.id
			});
			if (social && social.psID == constants.POST_SVC_TWITTER) {
				for (let key in idList) {
					test = _.find(this.props.socials.list, (social) => {
						return idList[key] == social.id;
					});
					if (test !== undefined) {
						if (test.psID == constants.POST_SVC_TWITTER) {
							++twitterCount;
						}
					}
				}
				let nextTwitterCount = twitterCount + 1;
				if (nextTwitterCount >= constants.MAX_TWITTER_OUTPUTS) {
					twitterMaxedOut = true;
				}
				if (twitterCount >= constants.MAX_TWITTER_OUTPUTS) {
					return;
				}
				if (twitterCount == 0) {
					mainTweeter = newId;
				}
				if (twitterCount >= 1 && this.props.singleTwitter) {
					return;
				}
			}

			idList.push(newId);
		} else {
			idList = _.without(idList, newId);
		}

		// run a quick check to see if a save is actually needed
		// or we're back to where we started
		isDirty = false;
		diff = _.difference(idList, this.state.originalSet);
		if (diff.length || idList.length < this.state.originalSet.length) {
			isDirty = true;
		}

		this.setState({
			isDirty: isDirty,
			selectedSocials: idList,
			twitterMaxedOut: twitterMaxedOut,
			mainTweeter: mainTweeter
		});

	}

	saveDialog() {
		let toAdd = this.getSocialsToAdd();

		// only show the postRecentDialog if a routeId is present
		// otherwise it's being used in a new route creation
		if (toAdd.length && this.props.routeId) {
			this.setState({ activeTab: 'postRecentDialog' });
		} else {
			this.saveHandler(0);
		}

	}

	saveDialogConfirm() {

		this.props.clearFilter('socials');
		this.props.closeAllModals();

		return this.saveHandler(1);

	}

	saveDialogCancel() {

		this.props.clearFilter('socials');
		this.props.closeAllModals();

		return this.saveHandler(0);

	}

	onSocialsSelected(e) {

		e.preventDefault();

		if (this.props.onSocialsSelected) {
			this.props.onSocialsSelected.apply(this, [this.state.selectedSocials]);
		}

	}

	getSocialsToAdd() {
		return _.difference(this.state.selectedSocials, this.state.originalSet);
	}

	saveHandler(postRecent) {

		let toAdd = [],
			toRemove = [],
			outputsToRemove = [],
			i = 0,
			constants = this.props.app.config.constants;


		toAdd = this.getSocialsToAdd();

		toRemove = _.difference(this.state.originalSet, this.state.selectedSocials);
		if (toRemove.length) {
			for (i = 0; i < this.props.outputs.length; ++i) {
				if (toRemove.indexOf(this.props.outputs[i].social.id) !== -1) {
					outputsToRemove.push(this.props.outputs[i].id);
				}
			}
		}

		// allow the interface to update the selected socials when creating a new route
		if (this.props.updateSelectedSocials !== undefined && typeof this.props.updateSelectedSocials === "function") {
			this.props.updateSelectedSocials({
				add: toAdd,
				remove: toRemove
			});
		}

		if (this.props.routeId) {
			// if (this.state.isDirty && toAdd.length === 0 && toRemove.length === 0 && this.state.mainTweeter) {
			// 	let output = _.find(this.props.outputs, function(output) {
			// 		return output.social.id == this.state.mainTweeter
			// 	}.bind(this));
			// 	if (output) {
			// 		output.role = constants.OR_ROLE_NORMAL;
			// 		this.props.updateOutput(output);
			// 	}
			//
			// } else {
			for (i = 0; i < outputsToRemove.length; ++i) {
				this.props.deleteOutput(outputsToRemove[i]);
			}


			for (i = 0; i < toAdd.length; ++i) {
				let output = {
						rID: this.props.routeId,
						paID: toAdd[i],
						activeFlag: true,
						postRecent: postRecent
					};

				if (toAdd[i] == this.state.mainTweeter) {
					output.role = constants.OR_ROLE_NORMAL;
				}
				this.props.createOutput(output);
			}


			//}

		}

		this.props.closeAllModals();

	}

	setMainTweeter(id) {
		let selectedSocials = this.state.selectedSocials,
			isDirty = this.state.isDirty;

		if (id) {
			if (selectedSocials.indexOf(id) === -1) {
				selectedSocials.push(id);
				isDirty = true;
			}
			if (id != this.state.mainTweeter) {
				isDirty = true;
			}
		}
		this.setState({
			mainTweeter: id,
			selectedSocials: selectedSocials,
			isDirty: isDirty
		});

	}

	resetTwitters() {
		let confirm = function() {
				let constants = this.props.app.config.constants,
					socials = this.state.selectedSocials,
					newSocials = [];

				for (let i = 0; i < socials.length; ++i) {
					let social = _.find(this.props.socials.list, function(social){
						return social.id == socials[i];
					}.bind(this));
					if (social && social.psID != constants.POST_SVC_TWITTER) {
						newSocials.push(socials[i]);
					}
				}

				this.setState({
					selectedSocials: newSocials,
					mainTweeter: 0,
					inceptionModal: null,
					isDirty: true
				});

			}.bind(this),
			cancel = function() {
				this.setInceptionModal(null);
			}.bind(this),

			modal = (
				<ConfirmModal
					cancelAction={cancel}
					confirmAction={confirm}
					modalCopy={"Deselecting your main Twitter will remove all retweeters too. Click on the main account in the tray to change it instead."}/>
			);

			this.setInceptionModal(modal);

	}

	render() {
		let modalContainer = null,
			modalTitle = 'Connect Social',
			modalHeader = null,
			modalContent = null,
			modalFooter = null,
			toAdd = this.getSocialsToAdd(),
			ret, message,
			activeTab = this.state.activeTab,
			twitterInput = false,
			constants = this.props.app.config.constants,
			selectionContext = 'modal',
			twitterCount = 0,
			inceptionModal = this.state.inceptionModal,
			footerStatus = null;

		if (this.props.activeRoute !== undefined &&
			this.props.activeRoute.inputs !== undefined &&
			this.props.activeRoute.inputs.length !== undefined) {
			for (let i = 0; i < this.props.activeRoute.inputs.length; ++i) {
				if (this.props.activeRoute.inputs[i].type !== undefined && this.props.activeRoute.inputs[i].type == constants.INPUT_TYPE_TWITTER) {
					twitterInput = true;
					break;
				}
			}
		};

		if (this.state.selectedSocials.length) {
			for (let i = 0; i < this.state.selectedSocials.length; ++i) {
				let social = _.find(this.props.socials.list, function(social) {
					return this.state.selectedSocials[i] == social.id
				}.bind(this));
				if (social !== undefined && social.psID == constants.POST_SVC_TWITTER) {
					++twitterCount;
				}
			}
		};


		if (this.props.context === 'bulk-modal') {
			modalTitle = 'Import to Socials';
			selectionContext = this.props.context;
		} else if (this.props.context === 'list-add') {
			selectionContext = this.props.context;
		} else if (this.props.context === 'reconnect') {
			modalTitle = "Reconnect your social";
		}

		if (activeTab === 'chooseType') {
			let extraClass = (this.props.context !== "input") ? "ts-modal narrow"  : "ts-modal";
			modalContent = (
				<TypeSelection
					{...this.props}
					extraClasses={extraClass}
					types={this.props.socials.types}
					switchView={this.switchView}
					recordPath={this.props.recordPath}
					router={this.props.router}
					redirect={this.props.redirect}
					onboarding={this.props.onboarding}
					twitterInput={twitterInput} />
			);
		} else if (activeTab === 'chooseAcct') {
			modalContent = (
				<div>
					<SocialSelection
						{...this.props}
						context={selectionContext}
						routeId={this.props.routeId}
						outputs={this.props.outputs}
						searchHandler={this.filterSocialsByName}
						filterHandler={this.filterSocialsByType}
						socialClickHandler={this.socialClickHandler}
						connectHandler={this.switchView}
						saveHandler={this.saveDialog}
						isDirty={this.state.isDirty}
						selectedSocials={this.state.selectedSocials}
						serviceId={this.state.serviceId}
						redirect={this.props.redirect}
						recordPath={this.props.recordPath}
						twitterInput={twitterInput}
						twitterCount={twitterCount}
						singleTwitter={this.props.singleTwitter}
						twitterMaxedOut={this.state.twitterMaxedOut}
						mainTweeter={this.state.mainTweeter}
						setMainTweeter={this.setMainTweeter}
						resetTwitters={this.resetTwitters}
						switchView={this.switchView} />
				</div>
			);

		} else if (activeTab === 'createfeed') {
			modalContent = (
				<CreateFeedOutputPanel
					{...this.props}
					switchView={this.switchView}
					onboarding={this.props.onboarding}
					twitterInput={twitterInput} />
			);
		} else if (activeTab === 'choosesubtype'){
			modalContent = (
				<FBTypeChooser
					{...this.props}
					onboarding={this.props.onboarding}
					switchView={this.switchView}/>
			);
		} else if (activeTab === 'providehandle') {
			modalContent = (
				<MastodonHandle
					{...this.props}
					onboarding={this.props.onboarding}
					switchView={this.switchView}/>
			);
		} else if (activeTab === 'blueskycreds') {
			modalContent = (
				<BlueskyCreds
					{...this.props}
					onboarding={this.props.onboarding}
					switchView={this.switchView}/>
			);
		}

		if (this.state.errors) {
			// display the errors
		}

		if (activeTab === "chooseAcct") {
			if (this.state.serviceId === constants.POST_SVC_TWITTER) {
				for (let i = 0; i < this.props.socials.counts.length; ++i) {
					if (this.props.socials.counts[i].type == constants.POST_SVC_TWITTER && this.props.socials.counts[i].count === 1) {
						footerStatus = (
							<a href="https://support.dlvrit.com/hc/en-us/articles/360004803754" target="_blank">New X (Twitter) accounts will post as retweets. Learn More.</a>
						);
					}
				}
			}
			if (this.props.context === 'bulk-modal') {
				modalFooter = (
					<div className="social-modal-footer">
						<SocialModalFooter
							user={this.props.user}
							footerStatus={footerStatus}
							context={this.props.context}
							numberSelected={this.state.selectedSocials.length}
							saveAction={this.onSocialsSelected}
							isDirty={this.state.isDirty} />
					</div>
				);
			} else {
				modalFooter = (
					<div className="social-modal-footer">
						<SocialModalFooter
							user={this.props.user}
							footerStatus={footerStatus}
							numberSelected={this.state.selectedSocials.length}
							backAction={this.switchView}
							saveAction={this.saveDialog}
							isDirty={this.state.isDirty} />
					</div>
				);
			}

		}
		modalContainer = (
			<div>
				{inceptionModal}
				<div className="social-modal-content">
					{modalContent}
				</div>
				{modalFooter}
			</div>
		);

		if (this.state.activeTab === 'postRecentDialog') {
			message = 'Would you like to share the most recent item to this social?';

			if (toAdd.length > 1) {
				message = 'Would you like to share the most recent item to these socials?';
			}
			ret = (
				<ConfirmPostRecentModal
					modalCopy={message}
					cancelAction={this.saveDialogCancel}
					confirmAction={this.saveDialogConfirm} />
			);
		}
		else {
			let closeAction = this.props.closeAllModals;
			if (this.props.closeCallback !== undefined) {
				closeAction = () => {
					this.props.closeCallback();
					this.props.closeAllModals();
				}
			}
			ret = (
				<Modal
					headerContent={modalTitle}
					menuContent={null}
					content={modalContainer}
					showClose={true}
					close={closeAction} />
			);
		}

		return ret;
	}
};

SocialModal.displayName = "SocialModal";

SocialModal.propTypes = {
	outputs: PropTypes.array,
	routeId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	setModal: PropTypes.func,
	router: PropTypes.object,
	context: PropTypes.string,
	recordPath: PropTypes.func,
	redirect: PropTypes.string,
	activeTab: PropTypes.string,
	onboarding: PropTypes.object,
	connectHandler: PropTypes.func,
	trialEligible: PropTypes.bool,
	twitterInput: PropTypes.bool,
	clearFilterOnClose: PropTypes.bool
};

SocialModal.defaultProps = {
	outputs: [],
	routeId: 0,
	setModal: null,
	router: null,
	context: '',
	redirect: '',
	activeTab: 'chooseType',
	onboarding: null,
	connectHandler: null,
	trialEligible: false,
	twitterInput: false,
	singleTwitter: false,
	noTwitter: false,
	clearFilterOnClose: false
};

export default RouteProvider(SocialModal);
